var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 1.33334C7.89999 1.33334 1.3335 7.89983 1.3335 16C1.3335 24.1002 7.89999 30.6667 16.0002 30.6667C24.1003 30.6667 30.6668 24.1002 30.6668 16C30.6668 7.89983 24.1003 1.33334 16.0002 1.33334ZM12.7998 10.8215C12.6668 10.9991 12.6668 11.3173 12.6668 11.9537V20.0461C12.6668 20.6825 12.6668 21.0007 12.7998 21.1783C12.9157 21.3331 13.0931 21.43 13.286 21.4437C13.5073 21.4596 13.775 21.2875 14.3103 20.9434L20.6044 16.8971C21.0689 16.5985 21.3012 16.4492 21.3814 16.2594C21.4515 16.0935 21.4515 15.9063 21.3814 15.7404C21.3012 15.5506 21.0689 15.4012 20.6044 15.1026L14.3103 11.0564C13.775 10.7123 13.5073 10.5402 13.286 10.556C13.0931 10.5698 12.9157 10.6667 12.7998 10.8215Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlack);
export default __webpack_public_path__ + "static/media/playBlack.0af3b1f365818c119d446f8925f33466.svg";
export { ForwardRef as ReactComponent };